<template>
	<div>
		<FlashMessage />

		<header>
			<h1>Jeopardy!</h1>

			<p v-if="isLoggedIn">
				Logged in as
				{{ authenticatedUser.firstname }}
				{{ authenticatedUser.lastname }}
			</p>
		</header>

		<nav v-if="isLoggedIn">
			<ul>
				<li>
					<RouterLink to="/command">Commands</RouterLink>
				</li>
				<li>
					<RouterLink to="/api_token">API tokens</RouterLink>
				</li>
				<li>
					<button @click.prevent="logout">Logout</button>
				</li>
			</ul>
		</nav>

		<RouterView />
	</div>
</template>

<script>
import auth from '@/modules/authentication/auth'

export default {
	name: 'App',
	components: {
	},
	data() {
		return {
			authenticatedUser: null,
		};
	},
	computed: {
		isLoggedIn() {
			return !!this.authenticatedUser;
		},
	},
	created() {
		auth.getAuthenticatedUser()
			.then(user => {
				this.authenticatedUser = user;
			})
		;

		auth.on('authenticationChange', (user) => {
			this.authenticatedUser = user;

			if (!user && this.$route.path !== '/login') {
				this.$router.replace('/login');
			}
		});
	},
	methods: {
		logout() {
			auth.logout();
		}
	},
};
</script>

<style>
@import url("https://use.typekit.net/pcn4kba.css");

* {
	box-sizing: border-box;
}

body {
	background: #ebebeb;
	font-family: 'sofia-pro', sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 100%;
}

input, textarea, select, option, button {
	font-family: 'sofia-pro', sans-serif;
	font-size: 1em;
}

._vue-flash-msg-body {
	z-index: 1;
}

button:focus {
	outline: 2px solid #2c6ae0;
}
</style>
